import { render, staticRenderFns } from "./MiPassword.vue?vue&type=template&id=0ff0260a&scoped=true"
import script from "@/components/mi-password/MiPassword.ts?vue&type=script&lang=ts&external"
export * from "@/components/mi-password/MiPassword.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/mi-password/mi-password.scss?vue&type=style&index=0&id=0ff0260a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff0260a",
  null
  
)

export default component.exports